import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { Toaster } from 'react-hot-toast'

// Portal Components
import OwnerPortal from '@features/owner/OwnerPortal'
import PartnerPortal from '@features/partner/PartnerPortal'
import ManagerPortal from '@features/manager/ManagerPortal'

// Auth Components
import { AuthProvider, useAuth } from '@features/auth/AuthContext'
import LoginPage from '@features/auth/LoginPage'
import ProtectedRoute from '@features/auth/ProtectedRoute'

// Theme
import { theme } from '@utils/theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
      refetchOnWindowFocus: false
    }
  }
})

function AppRoutes() {
  const { user } = useAuth()

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Owner Portal */}
      <Route path="/owner/*" element={
        <ProtectedRoute allowedRoles={['owner']}>
          <OwnerPortal />
        </ProtectedRoute>
      } />

      {/* Partner Portal - TEMPORARILY BYPASSED AUTH FOR DEMO */}
      <Route path="/partner/*" element={
        // <ProtectedRoute allowedRoles={['partner']}>
          <PartnerPortal />
        // </ProtectedRoute>
      } />

      {/* Manager Portal */}
      <Route path="/manager/*" element={
        <ProtectedRoute allowedRoles={['manager']}>
          <ManagerPortal />
        </ProtectedRoute>
      } />

      {/* Default redirect based on role */}
      <Route path="/" element={
        user ? (
          user.role === 'owner' ? (
            <Navigate to="/owner" />
          ) : user.role === 'partner' ? (
            <Navigate to="/partner" />
          ) : user.role === 'manager' ? (
            <Navigate to="/manager" />
          ) : (
            <Navigate to="/login" />
          )
        ) : (
          <Navigate to="/login" />
        )
      } />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            <AppRoutes />
            <Toaster position="top-right" />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}
